<!-- Templete  -->
<template> 
    <draggable v-bind="dragOptions" :emptyInsertThreshold="500"  :disabled="!enabled" class="list-group" ghost-class="ghost"   @start="dragging = true" @end="dragging = false">
    <div v-if="articleList.length>0">
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
      <Article0013 v-for="(article, index) in articleList" v-bind:key="index" v-bind:articlNo="article.article_no" v-bind:articleId="article.article_id" v-bind:articleTitle="article.title" v-bind:articleCategory="article.media_name" v-bind:articleDate="article.issue_date" v-bind:articlePages="article.issue_type" v-bind:articleSearchTerm="article.search_word"  v-bind:articlecomment="article.comment" v-bind:articleImage="article.articleImage" v-bind:articleDataSection="article.data_section"/>
    </transition-group>
    </div>
<div v-else>
  <p class="noresult">ヒット結果は0件です</p>
</div>
    </draggable>


</template>

<!-- Script  -->
<script>
 import draggable from 'vuedraggable';
 import Article0013 from './Article0013.vue';
export default {
    name: "simple",
    display: "Transitions",
    order: 3,
    props: {
      drag: Boolean,
      articleList: Array
    },
    components: {
      draggable,
      Article0013,	
    },
  data() {
    return {
      // enabled: true, in the below line for dragging 
      enabled: false,
      dragging: false
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
}
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}

label {
  font-size: 8pt;
  padding-left: 6px;
}

.el-checkbox {
  margin-right: 0px !important;
}
.noresult {
  text-align: center;
  margin-top: 100px;
  position: relative;
}
</style>
